export const LINKEDIN_SUPPORTED_TARGETING_LANGUAGES = [
  'Arabic',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'French',
  'German',
  'Hindi',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Malay',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Spanish',
  'Swedish',
  'Turkish',
];

export const LinkedInAudienceType = {
  COMPANY_NAMES: 'companyNames',
  COMPANY_INDUSTRIES: 'companyIndustries',
  JOB_SENIORITIES: 'jobSeniorities',
  JOB_FUNCTIONS: 'jobFunctions',
  JOB_TITLES: 'jobTitles',
};

export const LinkedInAudienceTypesInOrder = [
  LinkedInAudienceType.COMPANY_NAMES,
  LinkedInAudienceType.COMPANY_INDUSTRIES,
  LinkedInAudienceType.JOB_SENIORITIES,
  LinkedInAudienceType.JOB_FUNCTIONS,
  LinkedInAudienceType.JOB_TITLES,
];

export const LinkedInAudienceConfig = {
  [LinkedInAudienceType.COMPANY_NAMES]: {
    label: _TL_('Company'),
    helpTopic: 'pop_BA_LinkedIn_Company',
    helpLabel: _TL_('Click here to learn more about company'),
    placeholder: _TL_('Enter company name to search'),
    mutuallyExclusiveDisclaimer: _TL_('Company Names may not be ’AND’ed with Company Industries'),
    mutuallyExclusiveTypes: [
      LinkedInAudienceType.COMPANY_INDUSTRIES,
    ],
  },
  [LinkedInAudienceType.COMPANY_INDUSTRIES]: {
    label: _TL_('Industry'),
    helpTopic: 'pop_BA_LinkedIn_Industry',
    helpLabel: _TL_('Click here to learn more about industry'),
    placeholder: _TL_('Enter industry to search'),
    mutuallyExclusiveDisclaimer: _TL_('Company Industries may not be ’AND’ed with Company Names'),
    mutuallyExclusiveTypes: [
      LinkedInAudienceType.COMPANY_NAMES,
    ],
  },
  [LinkedInAudienceType.JOB_SENIORITIES]: {
    label: _TL_('Job seniority'),
    helpTopic: 'pop_BA_LinkedIn_JobSeniority',
    helpLabel: _TL_('Click here to learn more about job seniority'),
    placeholder: _TL_('Enter job seniority to search'),
    mutuallyExclusiveDisclaimer: _TL_('Job Seniorities may not be ’AND’ed with Job Titles'),
    mutuallyExclusiveTypes: [
      LinkedInAudienceType.JOB_TITLES,
    ],
  },
  [LinkedInAudienceType.JOB_FUNCTIONS]: {
    label: _TL_('Job function'),
    helpTopic: 'pop_BA_LinkedIn_JobFunction',
    helpLabel: _TL_('Click here to learn more about job function'),
    placeholder: _TL_('Enter job function to search'),
    mutuallyExclusiveDisclaimer: _TL_('Job Functions may not be ’AND’ed with Job Titles'),
    mutuallyExclusiveTypes: [
      LinkedInAudienceType.JOB_TITLES,
    ],
  },
  [LinkedInAudienceType.JOB_TITLES]: {
    label: _TL_('Job title'),
    helpTopic: 'pop_BA_LinkedIn_JobTitle',
    helpLabel: _TL_('Click here to learn more about job title'),
    placeholder: _TL_('Enter job title to search'),
    mutuallyExclusiveDisclaimer: _TL_('Job Titles may not be ’AND’ed with Job Seniorities or Job Functions'),
    mutuallyExclusiveTypes: [
      LinkedInAudienceType.JOB_SENIORITIES,
      LinkedInAudienceType.JOB_FUNCTIONS,
    ],
  },
};

export const LinkedInAudienceTypeCriterion = {
  [LinkedInAudienceType.COMPANY_NAMES]: 'CompanyName',
  [LinkedInAudienceType.COMPANY_INDUSTRIES]: 'Industry',
  [LinkedInAudienceType.JOB_FUNCTIONS]: 'JobFunction',
  [LinkedInAudienceType.JOB_TITLES]: 'JobTitle',
  [LinkedInAudienceType.JOB_SENIORITIES]: 'JobSeniority',
};

export const LinkedInAudienceStatus = {
  Active: 'Active',
  Deleted: 'Deleted',
};

export const LinkedInAudienceCompanySizeMap = {
  One: '1',
  TwotoTen: '2 - 10',
  EleventoFifty: '11 - 50',
  FiftyOnetoTwoHundred: '51 - 200',
  TwoHundredOnetoFiveHundred: '201 - 500',
  FiveHundredOnetoOneThousand: '501 - 1,000',
  OneThousandOnetoFiveThousand: '1,001 - 5,000',
  FiveThousandOnetoTenThousand: '5,001 - 10,000',
  OverTenThousand: '> 10,000',
};

export const AgeRanges = {
  EighteenToTwentyFive: _TL_('18 to 24'),
  TwentyFiveToThirtyFive: _TL_('25 to 34'),
  ThirtyFiveToFiftyFive: _TL_('35 to 54'),
  FiftyFiveAndAbove: _TL_('55+'),
};

export const Genders = {
  Female: _TL_('Female'),
  Male: _TL_('Male'),
};
